<template>
  <app-layout>
    <content-card>
      <h3 slot="title">{{ title }}</h3>

      <p slot="content" v-html="content" />
    </content-card>

    <step-publish
        :button-text="$t('content.buttonText')"
        :is-button-disabled="false"
        :class-object="{'card-white': true}"
        :redirect-url="redirectUrl">
      <template slot="stats">
        <slot name="stats" />
      </template>
      <!-- Clear default icon -->
      <template slot="icon">&#8203;</template>
    </step-publish>
  </app-layout>
</template>

<script>
import ContentCard from './ContentCard'
import StepPublish from '../step/StepPublish'
import AppLayout from '../layout/AppLayout'

export default {
  name: "Content",
  components: {
    ContentCard,
    StepPublish,
    AppLayout,
  },
  data() {
    return {
      redirectUrl: '/',
      title: null,
      content: null,
    }
  },
  methods: {
    getContent() {
      this.$http.get('/public/api/vsebina/' + this.$route.params.content_id, {
        credentials: true
      }).then(response => {
        if (response.body.vsebina) {
          this.content = response.body.vsebina;
          this.title = response.body.naslov
        } else {
          this.title = "404"
        }
      }, response => {
        console.error('Request failed.  Returned status of ' + response.status);
        this.title = "404"
      })
    }
  },
  created() {
    return this.getContent()
  }
}
</script>

<style lang="scss">

</style>




// WEBPACK FOOTER //
// src/components/content/Content.vue